require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconChevronLeft.tsx
var IconChevronLeft_exports = {};
__export(IconChevronLeft_exports, {
  default: () => IconChevronLeft_default
});
module.exports = __toCommonJS(IconChevronLeft_exports);

// src/assets/monochrome/chevronLeft.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgChevronLeft = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0984 5.78992C12.2102 5.67904 12.2989 5.54711 12.3595 5.40177C12.42 5.25643 12.4512 5.10057 12.4512 4.94313C12.4512 4.78568 12.42 4.62978 12.3595 4.48444C12.2989 4.33911 12.2102 4.20718 12.0984 4.0963C11.8749 3.87416 11.5726 3.7495 11.2576 3.7495C10.9425 3.7495 10.6402 3.87416 10.4168 4.0963L5.348 9.16517C5.12587 9.38863 5.00117 9.69094 5.00117 10.006C5.00117 10.3211 5.12587 10.6234 5.348 10.8468L10.4168 15.9038C10.6402 16.126 10.9425 16.2506 11.2576 16.2506C11.5726 16.2506 11.8749 16.126 12.0984 15.9038C12.3205 15.6804 12.4452 15.378 12.4452 15.063C12.4452 14.7479 12.3205 14.4456 12.0984 14.2221L7.87641 10.0001L12.0984 5.78992Z", fill: "#818898" }) });
var chevronLeft_default = SvgChevronLeft;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconChevronLeft.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconChevronLeft = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(chevronLeft_default, {}) });
};
IconChevronLeft.displayName = "IconChevronLeft";
var IconChevronLeft_default = IconChevronLeft;
